var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Track',{ref:"trackRef",attrs:{"iProp":_vm.trackProps,"loadStatus":_vm.loadStatus,"selecteds":_vm.selecteds}})
}
var staticRenderFns = []

export { render, staticRenderFns }